import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import MailOutline from "@material-ui/icons/MailOutline";
import { Redirect } from "react-router-dom";
import Swal from "sweetalert2";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import { bookingApi } from "functions/apis";
import AnnouncementForm from "./AnnouncementForm";
import { confirmContentImages, emptyAnnouncement } from "./AnnouncementShared";

const useStyles = makeStyles(styles);

const CreateAnnouncement = props => {
  const classes = useStyles();
  const [redirect, setRedirect] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [input, setInput] = useState(emptyAnnouncement);

  const signal = useRef(new AbortController());

  useEffect(() => {
    return () => signal.current.abort();
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setDisabled(true);
    if (!(await confirmContentImages(input.contentHtml))) {
      setDisabled(false);
      return;
    }
    bookingApi
      .post("Announcements", input, { signal: signal.current.signal })
      .then(id => {
        Swal.fire({
          title: "Success!",
          text: "Announcement created. Upload its banner now?",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Upload Banner",
          cancelButtonText: "Later"
        }).then(result =>
          setRedirect(
            result.isConfirmed
              ? "/admin/Announcement/UploadBanner/" + id
              : "/admin/Announcement/List"
          )
        );
      })
      .catch(error => {
        if (signal.current.signal.aborted) return;
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={redirect} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>CREATE ANNOUNCEMENT</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <AnnouncementForm
              input={input}
              setInput={setInput}
              disabled={disabled}
              onSubmit={handleSubmit}
              ready
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default CreateAnnouncement;

CreateAnnouncement.propTypes = {
  history: PropTypes.object
};
